import { FormikProps } from 'formik'
import React from 'react'
import { useTranslation } from 'react-i18next'

import TextAreaNew from '../../../common/components/InputFieldNew/TextAreaNew'

import ReserveFormFieldset from './ReserveFormFieldset'

interface Props
  extends Pick<
    FormikProps<{
      additionalInformation: string
    }>,
    'values' | 'handleChange' | 'handleBlur' | 'errors'
  > {
  additionalInformationMaxLength: number
}

const ReserveAdditionalInformationForm: React.FC<Props> = ({
  values,
  errors,
  handleChange,
  handleBlur,
  additionalInformationMaxLength,
}) => {
  const { t } = useTranslation()
  return (
    <ReserveFormFieldset legend={t('component.reserveAdditionalInformationForm.subHeading')}>
      <TextAreaNew
        id="additionalInformation"
        rows={4}
        label={t('component.reserveAdditionalInformationForm.label.additionalInformation')}
        helperText={errors.additionalInformation}
        error={Boolean(errors.additionalInformation)}
        characterCount={`${values.additionalInformation.length} / ${additionalInformationMaxLength}`}
        value={values.additionalInformation}
        onChange={handleChange}
        onBlur={handleBlur}
        maxLength={additionalInformationMaxLength}
      />
    </ReserveFormFieldset>
  )
}

export default ReserveAdditionalInformationForm
